module.exports = __webpack_public_path__ + "static/img/login-samu-04.27faa6f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/login-samu-04.png
// module id = ZXcl
// module chunks = 4